import React from "react";
import { Button } from "../../../components";
import { LearnMoreLink } from "./LearnMoreLink";

/**
 * Empty state displayed when no information pages exist.
 * @param {{ onCreateNewPage: () => void }} props
 */
export function EmptyState({ onCreateNewPage }) {
	return (
		<div className="infopage__emptyState">
			<div className="emptyState" />
			<h2>You don't have any information pages yet.</h2>
			<p>
				The information pages are ideal to store policies, procedures and more.
			</p>
			<p className="text-h2">
				Learn more about <LearnMoreLink />
			</p>
			<Button
				buttonType="primary"
				isActive
				onClick={onCreateNewPage}
				leftIcon="plus-circle"
			>
				Create new page
			</Button>
		</div>
	);
}
